import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/layouts/default.vue").then(m => m.default || m))
}